<style>
/* Manage the Html view size  for card preview*/
.card-wrapper {
  width: 175px;
  height: 255px;
  padding: 0;
  overflow: hidden;
}
.card-html-download-preview {
  width: 600px;
  border: 0px;
  bottom: 0px;
  height: 929px;
  overflow-y: hidden;
}

.card-html-download-preview {
  /*zoom: 0.51;*/
  -moz-transform: scale(0.28);
  -moz-transform-origin: 0 0;
  -o-transform: scale(0.28);
  -o-transform-origin: 0 0;
  -webkit-transform: scale(0.28);
  -webkit-transform-origin: 0 0;
}

/* @media screen and (-webkit-min-device-pixel-ratio:0) {
	.card-html-download-preview  {  }
} */

/* Hide scrollbar for Chrome, Safari and Opera */
.card-html-download-preview::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.card-html-download-preview {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

/*#################################################################
####################################################################
####################################################################*/

.negative-margin12 {
  margin-top: -12px;
  display: block;
}

.dialog-subtitle {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.457143px;
  color: rgba(0, 0, 0, 0.8);
}

.need-help-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #3e537f;
}
</style>

<template>
  <div>
    <v-dialog v-model="$store.state.common_dialog" max-width="455">
      <v-card>
        <v-icon
          class="float-right ma-3"
          @click="$store.state.common_dialog = !$store.state.common_dialog"
        >
          {{ mdiWindowClose }}
        </v-icon>
        <v-card-text class="text-center">
          <p class="dialog-title pt-5">{{ title }}</p>
        </v-card-text>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="10" md="10">
              <div class="pl-1">
                <slot />
              </div>
            </v-col>
          </v-row>
          <div class="text-center need-help-text">
            {{ $t("NEED_HELP") }}
            <a :href="`tel:${$store.state.support_contact}`">
              {{ $store.state.support_contact }}
            </a>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script type="text/javascript">
import { mdiWindowClose } from "@mdi/js";

export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      mdiWindowClose
    };
  }
};
</script>
